// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"_3piiG","hidden":"_2sW4W"};